import styled from 'styled-components';

export const Container = styled.div`
  margin-bottom: 60px;
  .card {
    cursor: ${(props) => (props.editing ? 'move' : 'default')};
  }
`;
